import LinkButton from '@/components/atoms/link-button/link-button';
import React from 'react';
import IScholarship from '@/models/viewModels/IScholarship';
import { ScholarshipIcon } from '@/components/atoms/icons';
import css from 'styled-jsx/css';
import { LinkButtonStyleType } from '@/constants/link-button-style-type';
import { RichText } from '@into-discovery/browsewebshared';
import scholarshipStyles from './scholarships.module.scss';

type Props = {
  scholarship: IScholarship;
  programType: string;
  brandColor: string;
};

function getStyles(uniBackgroundColor: string): { className: string; styles: JSX.Element } {
  return css.resolve`
    .scholarship-icon {
      fill: ${uniBackgroundColor};
    }
    .scholarship-title {
      color: ${uniBackgroundColor};
    }
  `;
}

export default function Scholarships({ scholarship, programType, brandColor }: Props) {
  const { className, styles } = getStyles(brandColor);

  return (
    <div className={`${scholarshipStyles.scholarships_item} rounded-border-6`}>
      {styles}
      <div className={`${className} scholarship-icon`}>
        <ScholarshipIcon />
      </div>
      <h4 className={`${className} scholarship-title mt-3`}>Scholarships</h4>
      {scholarship.intro && <RichText richText={scholarship.intro} />}
      <LinkButton
        link={scholarship.url}
        text={`${programType} Scholarships`}
        disclaimer
        linkStyle={LinkButtonStyleType.Secondary}
      />
    </div>
  );
}
